import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import {
  FacebookApiQueryParams,
  LoginWithFacebookResponseDTO,
} from "../models";

export abstract class FacebookApi {
  static async login({
    accessToken,
    referralLink,
    signedRequest,
  }: FacebookApiQueryParams) {
    const response = GbApiRequestService.post(
      "fbServlet",
      {
        requestType: "loginOrRegister",
        referralLink,
        signedRequest,
        accessToken,
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return withSchemaValidation(response, LoginWithFacebookResponseDTO);
  }
}
